import React, { Component } from 'preact/compat';
import PropTypes from 'prop-types';
import Anchor from 'react-material-web-components/src/Anchor';

import { List, ListItem, ListItemText } from '../List';

import withData from '../news/withData';
import withKeywords from '../news/withKeywords';

class Related extends Component {
  renderArticles() {
    const { newsArticles } = this.props;
    const articles = newsArticles.map(({
      url,
      title,
      id,
    }) => (
      <ListItem key={id}>
        <ListItemText>
          <Anchor
            href={url}
            title={title}
          >
            {title}
          </Anchor>
        </ListItemText>
      </ListItem>
    ));

    return articles;
  }
  render() {
    return (
      <List
        className="mostread"
      >
        {this.renderArticles()}
      </List>
    );
  }
}

Related.propTypes = {
  newsArticles: PropTypes.arrayOf(PropTypes.object),
};

Related.defaultProps = {
  newsArticles: [{}],
};

export default withKeywords(withData(Related));
